var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6", "offset-md": "3" } },
            [
              _vm.preferredMethod === "upload"
                ? _c(
                    "b-card",
                    {
                      staticClass: "py-4 px-5",
                      attrs: { "footer-class": "card-footer-center new-footer" }
                    },
                    [
                      _vm.isSuperAdmin
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "preferred-method",
                              attrs: {
                                size: "md",
                                variant: "secondary",
                                title: _vm.$t("TEMPLATE.CLONE")
                              },
                              on: {
                                click: function($event) {
                                  _vm.updatePreferredMethod("clone")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-clone" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "required",
                          attrs: {
                            label: _vm.$t("COMMON.TITLE"),
                            "label-for": "normalTitle"
                          }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.template.title,
                                expression: "template.title"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.$v.template.title.$error,
                              "is-valid": !_vm.$v.template.title.$invalid
                            },
                            attrs: {
                              id: "normalTitle",
                              type: "text",
                              placeholder: _vm.$t("TEMPLATE.ENTER_TITLE")
                            },
                            domProps: { value: _vm.template.title },
                            on: {
                              blur: function($event) {
                                _vm.$v.template.title.$touch()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.template,
                                  "title",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          !_vm.$v.template.title.required
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(_vm._s(_vm.$t("TEMPLATE.REQ_TITLE")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.template.title.valid
                            ? _c("b-form-invalid-feedback", [
                                _vm._v("Template Name can't allow symbols")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.template.title.minLength ||
                          !_vm.$v.template.title.maxLength
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(
                                  "Template Name length should be more than 3 and less than 30 characters"
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "required",
                          attrs: { label: "Brand", "label-for": "basicText" }
                        },
                        [
                          _c("b-form-select", {
                            class: {
                              "is-invalid": _vm.$v.template.brand.$error,
                              "is-valid": !_vm.$v.template.brand.$invalid
                            },
                            attrs: {
                              plain: true,
                              options: _vm.brandNames,
                              placeholder: "Select a Brand"
                            },
                            on: {
                              blur: function($event) {
                                _vm.$v.template.brand.$touch()
                              }
                            },
                            model: {
                              value: _vm.template.brand,
                              callback: function($$v) {
                                _vm.$set(_vm.template, "brand", $$v)
                              },
                              expression: "template.brand"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.$v.template.brand.required
                            ? _c("b-form-invalid-feedback", [
                                _vm._v("Brand is required")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("COMMON.DESCRIPTION"),
                            "label-for": "basicText"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "basicText",
                              type: "text",
                              placeholder: _vm.$t("TEMPLATE.ENTER_DESCR")
                            },
                            model: {
                              value: _vm.template.description,
                              callback: function($$v) {
                                _vm.$set(_vm.template, "description", $$v)
                              },
                              expression: "template.description"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "dropzone" } }, [
                        _vm._v(_vm._s(_vm.$t("FORMS.UPLOAD_MULTI_FORMS")))
                      ]),
                      _vm._v(" "),
                      _vm.canShowDropZone
                        ? _c("vueDropzone", {
                            ref: "formProcessDropZone",
                            attrs: {
                              id: "dropzone",
                              options: _vm.dropzoneOptions
                            },
                            on: {
                              "vdropzone-file-added": _vm.onAddingFile,
                              "vdropzone-sending": _vm.sendingEvent,
                              "vdropzone-max-files-exceeded":
                                _vm.onExceedingMaxFiles,
                              "vdropzone-success": _vm.onSuccess,
                              "vdropzone-removed-file": _vm.onRemovingFile,
                              "vdropzone-error": _vm.onError
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDropzoneBlank
                        ? _c("p", { staticClass: "text-danger mt-1" }, [
                            _vm._v(_vm._s(_vm.$t("TEMPLATE.REQ_FILE")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { slot: "footer" }, slot: "footer" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "padding-x-5",
                              attrs: {
                                type: "submit",
                                size: "sm",
                                variant: "secondary",
                                disabled: _vm.disableSave
                              },
                              on: { click: _vm.formUpload }
                            },
                            [
                              _vm.template.uploading
                                ? _c("i", {
                                    staticClass: "fa fa-spinner fa-spin mr-2",
                                    staticStyle: { "font-size": "18px" }
                                  })
                                : _vm._e(),
                              _c("span", { ref: "uploadText" }, [
                                _vm._v(_vm._s(_vm.$t("COMMON.SAVE")))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.preferredMethod === "clone"
                ? _c(
                    "b-card",
                    {
                      staticClass: "py-4 px-5",
                      attrs: { "footer-class": "card-footer-center new-footer" }
                    },
                    [
                      _vm.isSuperAdmin
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "preferred-method",
                              attrs: {
                                size: "md",
                                variant: "secondary",
                                title: _vm.$t("COMMON.UPLOAD")
                              },
                              on: {
                                click: function($event) {
                                  _vm.updatePreferredMethod("upload")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-upload" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "required",
                          attrs: {
                            label: _vm.$t("TEMPLATE.SELECT_FROM_ACCOUNT"),
                            "label-for": "basicText"
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: { plain: true, options: _vm.clone.accounts },
                            on: {
                              input: function($event) {
                                _vm.handleAccountChange()
                              }
                            },
                            model: {
                              value: _vm.clone.selectedFromAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.clone, "selectedFromAccount", $$v)
                              },
                              expression: "clone.selectedFromAccount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "required",
                          attrs: {
                            label: _vm.$t("TEMPLATE.TEMPLATE"),
                            "label-for": "basicText"
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.clone.templates
                            },
                            model: {
                              value: _vm.clone.selectedTemplate,
                              callback: function($$v) {
                                _vm.$set(_vm.clone, "selectedTemplate", $$v)
                              },
                              expression: "clone.selectedTemplate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "required",
                          attrs: {
                            label: _vm.$t("TEMPLATE.SELECT_TO_ACCOUNT"),
                            "label-for": "basicText"
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: { plain: true, options: _vm.clone.accounts },
                            model: {
                              value: _vm.clone.selectedToAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.clone, "selectedToAccount", $$v)
                              },
                              expression: "clone.selectedToAccount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { slot: "footer" }, slot: "footer" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "padding-x-5",
                              attrs: {
                                type: "submit",
                                size: "sm",
                                variant: "secondary",
                                disabled: _vm.disableClone
                              },
                              on: { click: _vm.cloneNewTemplate }
                            },
                            [_vm._v(_vm._s(_vm.$t("COMMON.CLONE")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-079f3100", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079f3100","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/New.vue
// module id = 1088
// module chunks = 2